import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

const SystemPageEditModal = ({ pageKey, pageData, onSave, onClose, saving }) => {
  const pageNames = {
    home: 'Homepage',
    search: 'Search / Listings',
    contact: 'Contact Page',
    create_listing: 'Add Listing'
  };

  const [formData, setFormData] = useState({
    title: pageData?.title || pageNames[pageKey] || '',
    seo: {
      title: pageData?.seo?.title || '',
      description: pageData?.seo?.description || '',
      keywords: pageData?.seo?.keywords || '',
      og_image: pageData?.seo?.og_image || ''
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(pageKey, formData);
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
      <div className="bg-zinc-900 rounded-xl border border-zinc-800 w-full max-w-2xl">
        <div className="border-b border-zinc-800 p-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-white">{pageNames[pageKey]} Edit SEO</h2>
          <button onClick={onClose} className="text-zinc-400 hover:text-white text-2xl">&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="space-y-2">
            <Label className="text-zinc-300">Page Title (Visible)</Label>
            <Input
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              className="bg-zinc-800 border-zinc-700 text-white"
            />
          </div>

          <div className="border-t border-zinc-800 pt-6">
            <h3 className="text-white font-medium mb-4">SEO Settings</h3>
            <div className="space-y-4">
              <div className="space-y-2">
                <Label className="text-zinc-400">SEO Title</Label>
                <Input
                  value={formData.seo.title}
                  onChange={(e) => setFormData({ ...formData, seo: { ...formData.seo, title: e.target.value } })}
                  className="bg-zinc-800 border-zinc-700 text-white"
                  placeholder="Page title for search engines"
                />
              </div>
              <div className="space-y-2">
                <Label className="text-zinc-400">Meta Description</Label>
                <Textarea
                  value={formData.seo.description}
                  onChange={(e) => setFormData({ ...formData, seo: { ...formData.seo, description: e.target.value } })}
                  className="bg-zinc-800 border-zinc-700 text-white"
                  rows={3}
                  placeholder="Description for search engines (150-160 characters recommended)"
                />
              </div>
              <div className="space-y-2">
                <Label className="text-zinc-400">Keywords</Label>
                <Input
                  value={formData.seo.keywords}
                  onChange={(e) => setFormData({ ...formData, seo: { ...formData.seo, keywords: e.target.value } })}
                  className="bg-zinc-800 border-zinc-700 text-white"
                  placeholder="keyword1, keyword2, keyword3"
                />
              </div>
              <div className="space-y-2">
                <Label className="text-zinc-400">OG Image URL</Label>
                <Input
                  value={formData.seo.og_image}
                  onChange={(e) => setFormData({ ...formData, seo: { ...formData.seo, og_image: e.target.value } })}
                  className="bg-zinc-800 border-zinc-700 text-white"
                  placeholder="https://example.com/og-image.jpg"
                />
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t border-zinc-800">
            <Button type="button" variant="outline" onClick={onClose} className="border-zinc-700 text-zinc-300">
              Cancel
            </Button>
            <Button type="submit" disabled={saving} className="bg-emerald-600 hover:bg-emerald-700">
              {saving ? 'Saving...' : 'Save Settings'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SystemPageEditModal;
